// extracted by mini-css-extract-plugin
export default {"root":"BannerMid-module-root"};